import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import WorkExperience from "./WorkExperience";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import OtherExperience from "./OtherExperience";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "5px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "5px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="About-img"
          >
            <img src={laptopImg} alt="About" className="img-fluid" />
          </Col>
        </Row>

        {/* Work Experience */}
        <WorkExperience />

        {/* Other Experience */}
        <h1 className="project-heading">
          <strong className="purple">Other</strong> Experience
        </h1>
        <OtherExperience />
      </Container>
    </Container>
  );
}

export default About;
